import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField, Typography, useTheme } from '@mui/material';

export const SimpleEditDailog = ({
    title,
    inpValue,
    handleSubmit,
    handleClose,
}) => {

    const [notes, setNotes] = useState(inpValue ? inpValue : "");
    const [isSaving, setIsSaving] = useState(false);
    const theme = useTheme();

    const onClose = () => {
        handleClose(false)
    };

    const onSubmit = async () => {
        setIsSaving(true);
        await handleSubmit(notes);
        onClose();
    }

    const handleNotesChange = (event) => {
        setNotes(event.target.value);
    };

    return (
        <>
            <Dialog
                open
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ 
                    m: 0,
                    p: 2,
                }}
            >
                <DialogTitle id="alert-dialog-title"
                    style={{
                        width: "100%",
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "Poppins",
                            fontSize: "16px",
                            fontWeight: 700,
                            lineHeight: "36px",
                            letterSpacing: "0px",
                            textAlign: "left",
                            color: theme.palette.text.primary,
                        }}
                    >
                        {title}
                    </Typography>
                    <CloseIcon
                        onClick={onClose}
                        style={{
                            height: 20,
                            width: 20,
                            cursor: "pointer",
                        }}
                    />
                </DialogTitle>
                <DialogContent style={{ width: 535 }}>
                    <TextField
                        multiline
                        maxRows={4}
                        minRows={4}
                        fullWidth
                        value={notes}
                        onChange={handleNotesChange}
                        placeholder="Notes"
                        variant="outlined"
                        style={{width: 487}}
                    />
                </DialogContent>
                <DialogActions style={{marginRight: 15, marginBottom: 10}}>
                    <Button
                        variant="text"
                        sx={{
                            textTransform: "none",
                            color: theme.palette.text.primary,
                            fontFamily: "Poppins, sans-serif",
                        }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={isSaving}
                        sx={{
                            textTransform: "none",
                            borderRadius: "80px",
                            bgcolor: theme.palette.button.main,
                            "&:hover": { bgcolor: theme.palette.buttonhover.main },
                            fontFamily: "Poppins, sans-serif",
                            color: "#FFFFFF",
                        }}
                        onClick={onSubmit}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}